module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('el-row', {
    staticClass: "row",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "news"
  }, [_c('router-link', {
    attrs: {
      "to": "/Articles"
    }
  }, [_c('span', {
    staticClass: "more more1"
  }, [_vm._v("查看更多>")])]), _vm._v(" "), _c('h4', [_vm._v("最新动态")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.Articles), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArticleDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("date")(item.creationTime, 'YYYY/MM/DD')))])], 1)
  })), _vm._v(" "), _c('el-row', {
    staticClass: "sub-row",
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entrusted"
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("采购下单")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entrusted"
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("租赁下单")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "sub-row",
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toTrustApply()
      }
    }
  }, [_vm._v("委托下单")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/newrepair"
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("维修下单")])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toShip()
      }
    }
  }, [_vm._v("我要发货")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-carousel', {
    staticClass: "carousel",
    attrs: {
      "height": "354px",
      "arrow": "never",
      "trigger": "click"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("../../assets/banner1.jpg")
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("../../assets/banner2.jpg")
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": require("../../assets/banner6.jpg")
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "query-card"
  }, [_c('h4', [_vm._v("物流派送查询")]), _vm._v(" "), _c('div', {
    staticClass: "img-wrapper text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logistics.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/logistics"
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    staticStyle: {
      "margin-top": "32px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("物流查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "query-card"
  }, [_c('h4', [_vm._v("库存查询")]), _vm._v(" "), _c('el-row', {
    staticClass: "form-item"
  }, [_c('el-select', {
    staticClass: "max-width",
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.inventorySearch.type),
      callback: function($$v) {
        _vm.inventorySearch.type = $$v
      },
      expression: "inventorySearch.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "代管库",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "委托共享库",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "form-item",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('el-input', {
    staticClass: "query-card-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
    },
    model: {
      value: (_vm.inventorySearch.word),
      callback: function($$v) {
        _vm.inventorySearch.word = $$v
      },
      expression: "inventorySearch.word"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "action-bar",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSeach('inventory')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "query-card"
  }, [_c('h4', [_vm._v("租赁价格查询")]), _vm._v(" "), _c('el-row', {
    staticClass: "form-item",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-input', {
    staticClass: "query-card-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
    },
    model: {
      value: (_vm.leaseSearch.word),
      callback: function($$v) {
        _vm.leaseSearch.word = $$v
      },
      expression: "leaseSearch.word"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "67px",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("热租产品：")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toLeasePriceByModelName('TP07打印机')
      }
    }
  }, [_vm._v("TP07打印机")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toLeasePriceByModelName('XE送钞平台')
      }
    }
  }, [_vm._v("XE送钞平台")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toLeasePriceByModelName('日立CS组件')
      }
    }
  }, [_vm._v("日立CS组件")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toLeasePriceByModelName('XE带测量站V模块')
      }
    }
  }, [_vm._v("XE带测量站V模块")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toLeasePriceByModelName('12款凭条打印机')
      }
    }
  }, [_vm._v("凭条打印机（12款）")])]), _vm._v(" "), _c('el-row', {
    staticClass: "action-bar action-bar-mg-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSeach('lease')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "query-card"
  }, [_c('h4', [_vm._v("维修价格查询")]), _vm._v(" "), _c('el-row', {
    staticClass: "form-item",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-input', {
    staticClass: "query-card-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
    },
    model: {
      value: (_vm.repairSearch.word),
      callback: function($$v) {
        _vm.repairSearch.word = $$v
      },
      expression: "repairSearch.word"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "67px",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("维修分类：")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(12)
      }
    }
  }, [_vm._v("循环模块")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(4)
      }
    }
  }, [_vm._v("出钞模块")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(2)
      }
    }
  }, [_vm._v("键盘")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(5)
      }
    }
  }, [_vm._v("显示器")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(10)
      }
    }
  }, [_vm._v("主机")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(7)
      }
    }
  }, [_vm._v("读卡器")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(6)
      }
    }
  }, [_vm._v("凭条打印机")]), _vm._v(" "), _c('a', {
    staticClass: "questionBtn",
    attrs: {
      "href": "javascript::"
    },
    on: {
      "click": function($event) {
        _vm.toRepairPriceByModuleId(13)
      }
    }
  }, [_vm._v("流水打印机")])]), _vm._v(" "), _c('el-row', {
    staticClass: "action-bar action-bar-mg-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "block-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSeach('repair')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row",
    attrs: {
      "gutter": 20,
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "max-height",
    staticStyle: {
      "min-height": "664px"
    }
  }, [_c('h4', [_vm._v("快速入口")]), _vm._v(" "), _c('el-menu', {
    staticClass: "menu",
    attrs: {
      "router": true
    },
    on: {
      "select": _vm.menuSelect
    }
  }, _vm._l((_vm.quickEntrys), function(entry) {
    return _c('el-menu-item', {
      key: entry.index,
      staticClass: "menu-item",
      attrs: {
        "index": entry.index
      }
    }, [_c('i', {
      staticClass: "fa fa-list-ul"
    }), _vm._v(_vm._s(entry.name))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('v-card', {
    staticClass: "max-height"
  }, [_c('div', {
    staticClass: "inventory"
  }, [_c('router-link', {
    attrs: {
      "to": "/entrusted"
    }
  }, [_c('el-button', {
    staticClass: "more",
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("查看更多")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "table-title"
  }, [_vm._v("库存查询")]), _vm._v(" "), _c('el-table', {
    staticClass: "horizontal-padding-10-table",
    attrs: {
      "data": _vm.HomeData.productQuantityItems
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物品名称",
      "formatter": _vm.formatProductTable,
      "width": "180px",
      "prop": "productName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "right-start"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" "), _c('div', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.productName.length > 12) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.productName.substring(0, 12) + '...') + "\n                    ")]) : _c('p', [_vm._v(_vm._s(scope.row.productName))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "brandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "modelName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项",
      "prop": "conditionName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区域",
      "prop": "regionName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "moduleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存数量",
      "prop": "quantity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "logistics"
  }, [_c('router-link', {
    attrs: {
      "to": "/logistics"
    }
  }, [_c('el-button', {
    staticClass: "more",
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("查看更多")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "table-title"
  }, [_vm._v("物流")]), _vm._v(" "), _c('el-table', {
    staticClass: "horizontal-padding-10-table",
    attrs: {
      "data": _vm.HomeData.deliveryOrders
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物流单号",
      "min-width": "100px",
      "prop": "orderCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("LogisticsState")(props.row.state)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户名称/编码",
      "min-width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.partnerName) + "/" + _vm._s(props.row.partnerCode))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送员",
      "min-width": "90px",
      "prop": "deliveryEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货时间",
      "min-width": "168px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row.shippedDate, 'YYYY/MM/DD HH:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "到货时间",
      "min-width": "168px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row.receivedDate, 'YYYY/MM/DD HH:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": '/logistics/' + props.row.orderId
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("详细")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "repair"
  }, [_c('router-link', {
    attrs: {
      "to": "/repair"
    }
  }, [_c('el-button', {
    staticClass: "more",
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("查看更多")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "table-title"
  }, [_vm._v("维修")]), _vm._v(" "), _c('el-table', {
    staticClass: "horizontal-padding-10-table",
    attrs: {
      "data": _vm.HomeData.repairOrders
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "维修单号",
      "prop": "orderCode",
      "min-width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "维修状态",
      "min-width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("OrderState")(props.row.state)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "维修时长",
      "min-width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.durationDays) + "天")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "处理时间",
      "min-width": "280px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row.startTime, 'YYYY/MM/DD HH:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": '/repair/' + props.row.orderId
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("详细")])], 1)]
      }
    }])
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row",
    attrs: {
      "gutter": 20,
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', {
    staticClass: "news",
    staticStyle: {
      "height": "100%",
      "min-height": "265px"
    }
  }, [_c('h4', [_vm._v("公告")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-indent": "2em",
      "line-height": "2em"
    }
  }, [_vm._v("\n          您好！感谢您长期以来对我们业务的支持与信任，我们始终坚持以服务为客户创造价值，经团队不断创新开发的客户应用系统正式上线了，欢迎参与操作体验。\n        ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('v-card', {
    staticClass: "menu-panel max-height"
  }, [_c('h4', [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("帮助中心")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "5px 20px 0"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("委托管理")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/委托业务简介"
    }
  }, [_vm._v("委托业务简介")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/委托订单列表"
    }
  }, [_vm._v("委托订单列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/租赁收入列表"
    }
  }, [_vm._v("租赁收入列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/出售收入列表"
    }
  }, [_vm._v("出售收入列表")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("租赁管理")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/租赁业务简介"
    }
  }, [_vm._v("租赁业务简介")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/租赁业务简介"
    }
  }, [_vm._v("租赁订单查询")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/租赁价格查询"
    }
  }, [_vm._v("租赁价格查询")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("库存查询")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/合作库库存"
    }
  }, [_vm._v("合作库库存")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/代管库库存"
    }
  }, [_vm._v("代管库库存")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("维修查询")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/维修业务简介"
    }
  }, [_vm._v("维修业务简介")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/维修下单列表"
    }
  }, [_vm._v("维修下单列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/维修价格查询"
    }
  }, [_vm._v("维修价格查询")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("物流信息查询")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/安全箱物流列表"
    }
  }, [_vm._v("安全箱物流列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/发货单列表"
    }
  }, [_vm._v("发货单列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/物流订单列表"
    }
  }, [_vm._v("物流订单列表")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("财务查询")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/委托收益报表"
    }
  }, [_vm._v("委托收益报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/委托销售报表"
    }
  }, [_vm._v("委托销售报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/维修支出报表"
    }
  }, [_vm._v("维修支出报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/物流支出报表"
    }
  }, [_vm._v("物流支出报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/租赁支出报表"
    }
  }, [_vm._v("租赁支出报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/保证金报表"
    }
  }, [_vm._v("保证金报表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/代管库支出报表"
    }
  }, [_vm._v("代管库支出报表")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/发货通知单"
    }
  }, [_vm._v("发货通知单")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/采购询价单"
    }
  }, [_vm._v("采购询价单")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/委托申请单"
    }
  }, [_vm._v("委托申请单")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/调度申请单"
    }
  }, [_vm._v("调度申请单")])], 1)])]), _vm._v(" "), _c('el-col', [_c('h4', {
    staticClass: "menu-title"
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('ul', {
    staticClass: "normal-list"
  }, [_c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/公司信息"
    }
  }, [_vm._v("公司信息")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/服务网点维护"
    }
  }, [_vm._v("服务网点维护")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/工程师信息维护"
    }
  }, [_vm._v("工程师信息维护")])], 1), _vm._v(" "), _c('li', {
    staticClass: "normal-item"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/helpList/在线反馈"
    }
  }, [_vm._v("在线反馈")])], 1)])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0045e692"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
// module id = 692
// module chunks = 0